import { render, staticRenderFns } from "./asset-plus-fitment-add-edit.vue?vue&type=template&id=3664e922&scoped=true&"
import script from "./asset-plus-fitment-add-edit.vue?vue&type=script&lang=js&"
export * from "./asset-plus-fitment-add-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3664e922",
  null
  
)

export default component.exports